import { EntityType } from 'app/agriculture/models/Entities';

interface EntityTypeConfigData {
    disableDelete: boolean;
    disableEdit: boolean;
}

export const EntityTypeToConfigDataMap: Partial<Record<EntityType, EntityTypeConfigData>> = {
    Note: {
        disableDelete: false,
        disableEdit: false,
    },
    Herd: {
        disableDelete: false,
        disableEdit: false,
    },
    Task: {
        disableDelete: false,
        disableEdit: false,
    },
    Device: {
        disableDelete: true,
        disableEdit: false,
    },
    ProtagAnimal: {
        disableDelete: true,
        disableEdit: true,
    },
};
